import { cn } from "@punchup/utils/cn";

export default function SoldOutBadge({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "w-[132px] h-8 px-2 py-1 bg-[#fef1f1] rounded justify-center items-center gap-2.5 inline-flex",
        className
      )}
    >
      <div className="text-[#ee3333] text-sm font-medium leading-normal">
        Sold out!
      </div>
    </div>
  );
}
